import React from 'react';
import clsx from 'clsx';

const SkeletonListItemDesktop = ({ items, cells, loading }) => {
  return (
    <>
      {loading &&
        [...Array(items)].map((e, index) => (
          <li
            className={clsx(
              'skeleton',
              'grid',
              `grid-cols-${cells}`,
              'py-3',
              'px-2',
              'gap-4',
              'border-b',
              'border-solid',
              'border-gray-300',
              'bg-white',
              '[&_:last-child]:border-b-0',
              'bg-white'
            )}
            key={index}
          >
            {[...Array(cells - 1)].map((e, index) => (
              <span
                className={clsx('skeleton', 'max-w-[100px] bg-gray-100')}
                key={index}
              >
                &nbsp;
              </span>
            ))}
          </li>
        ))}
    </>
  );
};

export default SkeletonListItemDesktop;
